export type MessageContentType =
	| "text"
	| "photo"
	| "group-photo"
	| "sticker"
	| "group-sticker"
	| "file"
	| "link";

//#region UI Message Content Types
export interface IUIMessageContent<T extends MessageContentType = any> {
	type: T;

	msgId: string;

	cliMsgId: string;
	fromUid: string;
	toUid: string;

	ttl?: number;
	sendDttm: number;
	localDttm?: number;
	serverTime?: number;

	content: unknown;
	urgency?: any;

	e2eeStatus?: number;

	isFirstInBlock?: boolean;
	isFirstInList?: boolean;
	isLastInBlock?: boolean;
	isLastInList?: boolean;
}

export interface IUITextMessageContent extends IUIMessageContent<"text"> {
	content: string;
}
export const isTextMessageContent = (
	content: IUIMessageContent,
): content is IUITextMessageContent => content.type === "text";

export interface IUIPhotoMessageContent extends IUIMessageContent<"photo"> {
	content: {
		title?: string;
		url: string;
		// Params contains the photo id in group photos,...
		params?: string;
	};
}
export const isPhotoMessageContent = (
	content: IUIMessageContent,
): content is IUIPhotoMessageContent => content.type === "photo";

export interface IUIGroupPhotoMessageContent extends IUIMessageContent<"group-photo"> {
	content: IUIPhotoMessageContent[];
}
export const isGroupPhotoMessageContent = (
	content: IUIMessageContent,
): content is IUIGroupPhotoMessageContent => content.type === "group-photo";

export interface IUIStickerMessageContent extends IUIMessageContent<"sticker"> {
	content: {
		id: number;
		cateId: number;
		type: number;
		text: string;
		uri: string;
		fkey: number;
		status: number;
		stickerUrl: string;
		stickerSpriteUrl: string;
		stickerWebpUrl: string | null;
		totalFrames: number;
		duration: number;
		effectId: number;
		checksum: string | null;
		ext: number;
		source: number;
		fss: any | null;
		fssInfo: any | null;
		version: number;
		extInfo: any | null;
		fetchTs: number;
		updateState: number;
	};
}
export const isStickerMessageContent = (
	content: IUIMessageContent,
): content is IUIStickerMessageContent => content.type === "sticker";

export interface IUIGroupStickerMessageContent extends IUIMessageContent<"group-sticker"> {
	content: IUIStickerMessageContent[];
}
export const isGroupStickerMessageContent = (
	content: IUIMessageContent,
): content is IUIGroupStickerMessageContent => content.type === "group-sticker";

export interface IUIFileMessageContent extends IUIMessageContent<"file"> {
	content: {
		title?: string;
		url: string;
	};
}
export const isFileMessageContent = (
	content: IUIMessageContent,
): content is IUIFileMessageContent => content.type === "file";

export interface IUILinkMessageContent extends IUIMessageContent<"link"> {
	content: {
		title?: string;
		url: string;
	};
}
export const isLinkMessageContent = (
	content: IUIMessageContent,
): content is IUILinkMessageContent => content.type === "link";

//#endregion

export type MessageContent<T extends MessageContentType> = T extends "text"
	? IUITextMessageContent
	: T extends "photo"
	? IUIPhotoMessageContent
	: T extends "group-photo"
	? IUIGroupPhotoMessageContent
	: T extends "sticker"
	? IUIStickerMessageContent
	: T extends "group-sticker"
	? IUIGroupStickerMessageContent
	: T extends "file"
	? IUIFileMessageContent
	: T extends "link"
	? IUILinkMessageContent
	: never;

export interface IUIMessageReaction {
	msgId: string;
	reactionId: string;
	reactions: {
		uid: string;
		reaction: string;
		count: number;
	}[];
}

export interface IUIMessageSender {
	uid: string;
	name: string;
	displayName?: string;
	avatarUrl?: string;
}

export interface IUIMessageStatus {
	msgId: string;
	status: "sending" | "sent" | "delivered" | "read";
}

export interface ItemData {
	id: string;
	content: string;
}
